import { GridColumnType } from "../../../data/gridColumnType";

export const OtherRepTableConfig = {
    columns: [
        {
            name: "Name of Other Rep",
            fieldName: "nameOfMainRepresentative",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Email Address",
            fieldName: "email",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "	Contact Number",
            fieldName: "contactNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            customWrapper: [
                {
                    name: "RESETPASSWORD",
                    label: "Reset Password",
                },
                {
                    name: "EDITINFO",
                    label: "Update Details",
                },
            ],
            defaultAction: {
                allowEdit: false,
                allowDelete: false,
            },
        },
    ],

};
